import { getAssignedCnt } from '@/services/notiApi'

const workspace = {
  state: () => ({
    openPref: null,
    assignedInfo: null,
  }),
  mutations: {
    // 상태 정보 설정
    setOpenPref(state, openPref) {
      state.openPref = openPref
    },
    // Assigned 카운트 설정
    setAssignedInfo(state, assignedInfo) {
      state.assignedInfo = assignedInfo
    },
  },
  actions: {
    // 로딩 화면 설정
    async setOpenPref({ commit }, openPref) {
      commit('setOpenPref', openPref)
    },
    // Assigned 카운트 설정
    async getAssignedCnt({ commit }, wsId) {
      let result = await getAssignedCnt(this._vm, wsId)
      commit('setAssignedInfo', result)
    },
  },
  getters: {
    openPref(state) {
      return state.openPref
    },
    assignedInfo(state) {
      return state.assignedInfo
    },
  },
}

export default workspace
